<template>
    <div>
        <UserNavigation/>
        <CartInfo/>
        <div class="container">
            <div class="row" v-if="item">
                <div class="col-sm-6">
                    <img class="card-img-top" :src="item.imageUrl" @error="$event.target.src='https://i.ibb.co/S5zDRCH/logo.png'" alt='Slika nije pronadjena'/>
                </div>

                <div class="col-sm-6">
                    <h1 class="bottom-padding">{{item.name}}</h1>

                    <h3 v-if="!item.available" style="color: #B82E24">Proizvod trenutno nije dostupan!</h3>
                    <div v-else class="price-text bottom-padding">
                        <h3 :style="item.discount ? 'text-decoration:line-through' : ''">
                            {{ item.price + ' RSD' }}
                        </h3>
                        <h3 style="margin-left: 10px">
                            {{ item.discount ? item.price - (item.price * item.discount / 100) + ' RSD' : '' }}
                        </h3>
                    </div>

                    <p class="description-text">{{ item.description }}</p>

                    <p><strong>Sastojci:</strong> {{item.ingredients}}</p>

                    <p><strong>Dimenzije:</strong> {{item.width}}x{{item.height}}x{{item.thickness}}mm</p>

                    <p><strong>Težina:</strong> {{item.weight}}g</p>

                    <!-- Smell selection for candles -->
                    <div v-if="item.category === 'CANDLE'" class="form-group bottom-padding">
                        <label><strong>Odaberi miris:</strong></label>
                        <div v-if="isFetchingItemSmells" class="text-muted">
                            Učitavanje mirisa...
                        </div>
                        <div v-else-if="itemSmells.length === 0" class="text-muted">
                            <small>Nema dostupnih mirisa za ovu sveću.</small>
                        </div>
                        <div v-else>
                            <b-form-select 
                                v-model="selectedSmell" 
                                :options="smellOptions" 
                                placeholder="Odaberi miris"
                                class="smell-select"
                                @change="onSmellChange">
                            </b-form-select>
                            <small class="form-text text-muted">
                                Molimo vas odaberite miris koji želite
                            </small>
                        </div>
                    </div>

                    <form @submit="addToCart">
                        <div class="amount-row">
                            <p><strong>Količina: </strong></p>
                            <button class="amount-button" type="button" @click="subtractAmount" :disabled="amountOrdered <= 1">-</button>
                            <p>{{ amountOrdered }}</p>
                            <button class="amount-button" type="button" @click="addAmount" :disabled="amountOrdered >= item.amountInStock">+</button>
                        </div>
                        <button type='submit'>
                            Dodaj u korpu
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import UserNavigation from '../../UserNavigation'
    import CartInfo from '@/component/user/cart/CartInfo'


    export default {
        name: 'ShopItemDetails',
        components: {
            UserNavigation,
            CartInfo
        },
        data() {
            return {
                itemId: parseInt(this.$route.params.id),
                amountOrdered: 1,
                selectedSmell: null
            }
        },
        created() {
            this.fetchItemById(this.itemId)
        },
        beforeDestroy() {
            this.selectedSmell = null
        },
        computed: {
            ...mapGetters([
                'getItemById',
                'getItems',
                'getItemSmellsByItem',
                'isFetchingItemSmellsByItem'
            ]),

            item: {
                get() {
                    return this.getItemById(this.itemId)
                }
            },

            itemSmells() {
                return this.getItemSmellsByItem(this.itemId)
            },

            isFetchingItemSmells() {
                return this.isFetchingItemSmellsByItem(this.itemId)
            },

            smellOptions() {
                if (!this.itemSmells || this.itemSmells.length === 0) {
                    return []
                }
                
                const options = [
                    {
                        text: 'Odaberi miris koji želiš',
                        value: null,
                        disabled: true
                    }
                ]
                
                return options.concat(this.itemSmells.map(smell => ({
                    text: smell.name || `Miris ${smell.id}`,
                    value: smell.id
                })))
            }
        },
        watch: {
            item(newItem) {
                if (newItem && newItem.category === 'CANDLE') {
                    this.fetchItemSmellsByItemId(this.itemId)
                }
            }
        },
        methods: {
            ...mapActions([
                'fetchItemById',
                'addCartItem',
                'fetchItemSmellsByItemId'
            ]),

            addAmount() {
                this.amountOrdered += 1
            },

            subtractAmount() {
                this.amountOrdered -= 1
            },

            addToCart(e) {
                e.preventDefault()
                
                // Validate smell selection for candles
                if (this.item.category === 'CANDLE') {
                    if (this.itemSmells.length === 0) {
                        this.$notify({
                            group: 'errors',
                            title: 'Greška!',
                            text: 'Ova sveća trenutno nema dostupnih mirisa'
                        })
                        return
                    }
                    
                    if (!this.selectedSmell || this.selectedSmell === null) {
                        this.$notify({
                            group: 'errors',
                            title: 'Greška!',
                            text: 'Molimo vas odaberite miris za sveću'
                        })
                        return
                    }
                }

                const cartItem = {
                    id: this.item.id,
                    name: this.item.name,
                    imageUrl: this.item.imageUrl,
                    price: this.item.price,
                    discount: this.item.discount,
                    amountInStock: this.item.amountInStock,
                    weight: this.item.weight,
                    amountOrdered: this.amountOrdered
                }

                if (this.item.category === 'CANDLE' && this.selectedSmell) {
                    const selectedSmellData = this.itemSmells.find(smell => smell.id === this.selectedSmell)
                    cartItem.selectedSmell = selectedSmellData
                    cartItem.smellId = this.selectedSmell
                }

                this.addCartItem(cartItem)
                

            },

            onSmellChange() {
                this.amountOrdered = 1
            }
        }
    }
</script>

<style scoped>
	* {
		background: #F0EAD6;
	}

    p {
        font-size: 15px;
    }

    .row {
        padding: 15px 0;
    }

    .price-text {
        display: flex;
    }

    .amount-row {
        display: flex;
        align-items: baseline;
    }

    .amount-button {
        border: none;
        margin-left: 5px;
        margin-right: 5px;
        font-weight: bold;
        padding: 4px 16px;
        background: transparent;
    }

    /*.amount-row p {*/
    /*    font-size: 18px;*/
    /*}*/

    .amount-button:hover:enabled {
        color: #42A85F;
    }

    button[type='submit'] {
        background: transparent;
        color: #967bb6;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: bold;
        width: 100%;
        padding: 15px;
        border: 1px solid #967bb6;
        border-radius: 0;
        cursor: pointer;
    }

    button[type='submit']:hover,
    button[type='submit']:active,
    button[type='submit']:focus {
        background: transparent;
        border: 1px solid #6f5193 ;
        color: #6f5193 ;
    }

    .bottom-padding {
        padding-bottom: 10px;
    }

    .smell-select {
        background: #F0EAD6;
        border: 2px solid #967bb6;
        border-radius: 8px;
        color: #333333;
        font-size: 14px;
        padding: 16px 20px;
        width: 100%;
        min-width: 250px;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        appearance: none;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 16px;
        padding-right: 50px;
        position: relative;
        line-height: 1.4;
        height: auto;
        min-height: 50px;
        display: flex;
        align-items: center;
    }

    .smell-select:hover {
        border-color: #967bb6;
        box-shadow: 0 4px 8px rgba(150, 123, 182, 0.2);
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23967bb6' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
    }

    .smell-select:focus {
        outline: none;
        border-color: #6f5193;
        box-shadow: 0 0 0 3px rgba(111, 81, 147, 0.1);
        background-color: #F0EAD6;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236f5193' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
    }

    .smell-select option {
        background: #F0EAD6;
        color: #333333;
        padding: 12px 16px;
        font-size: 14px;
        line-height: 1.4;
    }

    .smell-select option:hover {
        background: #e8e0c8;
    }

    .smell-select option:checked {
        background: #d8d0b8;
        color: #6f5193;
    }

    .form-group label strong {
        color: #333333;
        font-size: 16px;
        margin-bottom: 8px;
        display: block;
    }

    .form-group .text-muted {
        color: #666666 !important;
        font-size: 13px;
        margin-top: 6px;
        display: block;
    }

    .form-group .text-muted small {
        color: #888888 !important;
        font-style: italic;
    }

    h1 {
        font-family: "Monotype Corsiva", cursive;
        font-weight: bold;
        font-style: italic;
        font-size: 3em;
    }

  .description-text {
    white-space: pre-line;
  }
</style>
